var _circle, _circle2, _circle3, _circle4, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckMarkWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 173,
    viewBox: "0 0 172 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86.1501,
    r: 86,
    fill: "#56B320",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 86.5,
    cy: 85.6501,
    r: 72.5,
    fill: "#56B320",
    fillOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 86,
    cy: 86.1501,
    r: 59,
    fill: "#56B320",
    fillOpacity: 0.4
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 87.1501,
    r: 40,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.6841 42.4001C77.0312 42.4001 68.5726 44.966 61.3779 49.7734C54.1833 54.5807 48.5757 61.4135 45.2644 69.4077C41.953 77.402 41.0866 86.1987 42.7747 94.6853C44.4628 103.172 48.6296 110.968 54.7482 117.086C60.8667 123.205 68.6622 127.371 77.1489 129.06C85.6356 130.748 94.4322 129.881 102.427 126.57C110.421 123.259 117.254 117.651 122.061 110.456C126.868 103.262 129.434 94.8031 129.434 86.1501C129.434 74.5469 124.825 63.4189 116.62 55.2142C108.415 47.0095 97.2873 42.4001 85.6841 42.4001ZM79.4341 103.621L63.8091 87.9964L68.7797 83.0251L79.4341 93.6789L102.59 70.5251L107.577 75.4811L79.4341 103.621Z",
    fill: "#56B320"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMarkWave);
export default __webpack_public_path__ + "static/media/CheckMarkWave.caf18ee620c56485da3fe9657425ce81.svg";
export { ForwardRef as ReactComponent };